"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var WithPlayers_1 = __importDefault(require("./WithPlayers"));
var WithoutPlayers_1 = __importDefault(require("./WithoutPlayers"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MAX_PLAYERS = 20;
var TournamentInGame = function () {
    var _a, _b, _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var data = (0, swr_hooks_1.useActiveTournaments)().data;
    var currentTournament = data === null || data === void 0 ? void 0 : data[0];
    var playersCount = ((_a = currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.topScores) === null || _a === void 0 ? void 0 : _a.length) || 0;
    var emptyPlayers = (0, react_1.useMemo)(function () {
        return (0, apps_shared_1.generateEmptyTournamentArray)(playersCount, MAX_PLAYERS, {
            maxWidthName: 90,
            maxWidthResults: 60,
        });
    }, [playersCount]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.torunamentWrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.currentTourTitle },
                react_1.default.createElement("span", null, (_b = currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.baseTournament) === null || _b === void 0 ? void 0 : _b.name)),
            (currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.endDate) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.timerWrapper },
                react_1.default.createElement(ui_components_1.Timer, { endDate: currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.endDate, inGame: true })))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bestPlayersInTournament },
            react_1.default.createElement("div", null, (currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.topScores) &&
                (currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.topScores.length) > 0 ? (react_1.default.createElement(WithPlayers_1.default, { topPlayers: ((_c = currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.topScores) === null || _c === void 0 ? void 0 : _c.slice(0, 25)) || [], emptyPlayers: emptyPlayers })) : (react_1.default.createElement(WithoutPlayers_1.default, { emptyPlayers: emptyPlayers, showWaitPlayers: false }))))));
};
exports.default = TournamentInGame;
